import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "sticky-table__cell__separator" }, null, -1)

import AdminApi from "@/api/AdminApi";
import { useAuthStore } from "@/store/AuthModule";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersTableTabComponent',
  setup(__props, { expose: __expose }) {

const api = new AdminApi();

const authStore = useAuthStore();

let users = ref([]);
const loading = ref(false);
const selected = ref([]);
const tableRef = ref();
const searching = ref("");

const pagination = ref({
  descending: false,
  page: 1,
  rowsPerPage: 7,
});

const columns = [
  {
    name: "fio",
    required: true,
    label: "ФИО",
    align: "left",
    field: (row: { firstName: string; lastName: string }) =>
      row.lastName + " " + row.firstName,
    format: (val: any) => `${val}`,
    style: "min-width: 250px;",
    sortable: true,
  },
  {
    name: "assignedTests",
    align: "left",
    label: "Назначенные тесты",
    field: "assignedTests",
    style: "min-width: 354px; text-wrap: balance;",
    sortable: false,
    format: (val: any, row: any) =>
      val.length === 0 ? "Нет" : getNamesOfAssignedTests(val),
  },
  {
    name: "email",
    align: "left",
    label: "Email",
    field: "email",
    sortable: true,
  },
];

function getNamesOfAssignedTests(field: any) {
  let namesArray = [];
  if (field.length === 1) {
    namesArray.push(field[0].tesSetName);
  } else {
    for (let i = 0; i < field.length; i++) {
      namesArray.push(field[i].tesSetName);
    }
  }
  return namesArray.join("; ");
}

async function getUsers() {
  loading.value = true;
  await api.loadUsers().then((res) => {
    users.value = res;
    loading.value = false;
  });
}

__expose({
  selected,
});

onMounted(async () => {
  await getUsers();
});

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    class: "sticky-table",
    flat: "",
    ref_key: "tableRef",
    ref: tableRef,
    title: "",
    rows: _unref(users),
    columns: columns,
    loading: loading.value,
    filter: searching.value,
    "row-key": "azureId",
    selection: "multiple",
    pagination: pagination.value,
    "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((pagination).value = $event)),
    selected: selected.value,
    "onUpdate:selected": _cache[2] || (_cache[2] = ($event: any) => ((selected).value = $event))
  }, {
    "top-right": _withCtx(() => [
      _createVNode(_component_q_input, {
        class: "base-input search",
        modelValue: searching.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searching).value = $event)),
        placeholder: "Поиск...",
        dense: true
      }, {
        append: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "search" })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    "body-cell": _withCtx((props) => [
      _createVNode(_component_q_td, {
        class: "sticky-table__cell",
        props: props
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.value) + " ", 1),
          _hoisted_1
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    _: 1
  }, 8, ["rows", "loading", "filter", "pagination", "selected"]))
}
}

})